<template>
	<div v-if="!loading">
		<filters
			:event-loading="eventLoading"
			:site="site"
			:default-include="defaultInclude"
			:export-fermenters="exportFermenters"
			:show-empty.sync="showEmpty"
			:show-out-of-spec.sync="showOutOfSpec"
			:computed-tank-groups="computedTankGroups"
			:selected-tank-group.sync="selectedTankGroup"
			:search.sync="search"
			:date.sync="date"
			:period.sync="period">
		</filters>

		<fermenters v-if="$route.name == 'dashboard' || $route.name == 'dashboard.tank-group'" :fermenters="computedFermenters" :selected-tank-group.sync="selectedTankGroup"></fermenters>
		<bulk-entry v-else :fermenters="computedFermenters" :date="date" :selected-tank-group="selectedTankGroup" :search="search" :period="period"></bulk-entry>

		<div class="modal fade" id="dashboard_help_modal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
						<h4 class="modal-title" id="actionsTitle">Help</h4>
					</div>
					<div class="modal-body">
						<p>
							The dashboard gives you an overview of ferment status. Clicking on the fermenter name opens that ferment.
						</p>

						<p>
							You can search and filter through fermenters and tank groups using the options in the top bar.
						</p>

						<p>
							Clicking the <i class="fa fa-star-o" style="font-weight: bold"></i> in the top right corner of the ferment widget saves the ferment to the favourites group for faster access.
						</p>

						<img src="/static/img/dashboard-help.png">
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
	.gauge-alerts > .alert {
		border: none;
		margin-bottom: 1px;
	}
</style>

<script>
import { tankGroups, site, fermenters, loading, eventLoading } from 'vx/getters'
import { TankGroups as TankGroupActions, Fermenters as FermenterActions, App as AppActions } from 'vx/actions'
import Alert from 'utils/alert'
import Notify from 'utils/notify'
import Vue from 'vue'
import Fermenters from './fermenters'
import BulkEntry from './bulk-entry'
import Filters from './filters'
import moment from 'moment'

export default {
	components: {
		Fermenters,
		BulkEntry,
		Filters
	},

	vuex: {
		getters: {
			tankGroups,
			fermenters,
			site,
			loading,
			eventLoading
		},

		actions: {
			allTankGroups: TankGroupActions.all,
			allFermenters: FermenterActions.all,
			exportFermenters: FermenterActions.exportDashboardData,
			favouriteFermenter: FermenterActions.favourite,
			setTitle: AppActions.title
		}
	},

	route: {
		canReuse: false,

		activate() {
			this.$dispatch('loading');
		},

		data() {
			this.allFermenters(this.site.id, this.defaultInclude).then(() => {
				this.$dispatch('loaded');

				Vue.nextTick(this.boot);
			});
		}
	},

	data() {
		return {
			period: false,
			search: '',
			date: moment().format('DD/MM/YYYY'),
			selectedTankGroup: 'all',
			showEmpty: false,
			showOutOfSpec: false,
			defaultInclude: [
				'tankGroup',
				'currentFerment.gauge',
				'currentFerment.dailyData.action',
				'currentFerment.dailyData.analysis',
				'currentFerment.juiceAnalysis',
				'currentFerment.blendComponents'
			]
		}
	},

	ready() {
		this.setTitle('Dashboard');
	},

	computed: {
		computedFermenters() {
			return this.fermenters.filter(fermenter => {
				let shouldBeIncluded = true;

				if (this.showEmpty && ! fermenter.currentFerment){
					shouldBeIncluded = false;
				}

				// For out of spec fermenters we do not want to include those that do not have a current
				// ferment. We also do not want to include those that have a "Good" status, or ones
				// that do not have enough data.
				if (
					this.showOutOfSpec && (
						(fermenter.currentFerment && (fermenter.currentFerment.data.gauge.data.status < 10 || this.fermenterHasEnoughData(fermenter))) || ! fermenter.currentFerment)
				) {
					shouldBeIncluded = false;
				}

				if (this.selectedTankGroup == 'favourites' && ! fermenter.favourite){
					shouldBeIncluded = false;
				}

				if (fermenter.tank_group_id != this.selectedTankGroup && $.isNumeric(this.selectedTankGroup)) {
					shouldBeIncluded = false;
				}

				if (this.$options.filters.filterBy(fermenter, this.search).length == 0){
					shouldBeIncluded = false;
				}

				return shouldBeIncluded;
			});
		},

		computedTankGroups(){
			return $.merge([{ name: 'Favourites', value: 'favourites' }, { name: 'All', value: 'all' }], this.tankGroups.map(tankGroup => {
				return { name: tankGroup.name, value: tankGroup.id };
			}))
		}
	},

	methods: {
		boot() {
			if (this.$route.params.tankGroupId) {
				this.tankGroups.forEach(tankGroup => {
					if (tankGroup.id == this.$route.params.tankGroupId) {
						this.selectedTankGroup = tankGroup.id;
					}
				});
			} else {
				this.selectedTankGroup = 'all';
			}

			$('.ferments').on('click', '.favourite', event => {
				let target = $(event.target).attr('id'),
					fermenter = parseInt(target.substr(target.indexOf('_') + 1));

				this.favouriteFermenter(fermenter, this.site.id).then(response => {
					if(!response.body.data.favourite) {
						Notify.success('Fermenter no longer favourited.');
					}else {
						Notify.success('Fermenter favourited.');
					}
				});

			});
		},

		fermenterHasEnoughData(fermenter) {
			return fermenter.currentFerment.data.dailyData.data.length <= 4 && parseFloat(fermenter.currentFerment.data.gauge.data.predicted_duration) == 99;
		}
	}
};
</script>



// WEBPACK FOOTER //
// index.vue?306862b3